import { css } from "@emotion/react";

/* チャット画面コンテナ */
export const cht_headber = css`
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        width: 100%;
        padding: 10px;
        //height: 100px;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px;
        transition: height 1s ease 0s;        
    `

export const cht_headber_title = css`
    padding: 10px 20px;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0.1em;
`

export const bubble = css`
    position: relative;
    display: inline-block;
    padding: 10px 10px 10px 12px;
    border-radius: 8px;
    transition: opacity 800ms linear 0s;
`

export const cht_agent_bubble_cont = css`
    font-size: 18px;
    line-height: 1.8;
    color: #333;
    max-width: calc(100% - 60px);
    ::after {                
            display: block;
            width: 0px;
            content: "";
            position: absolute;
            top: 8px;
            bottom: auto;
            left: -6px;
            border-style: solid;
            border-width: 7px 7px 7px 0px;
        }
        a {
            color: #3A76A4;
        }
  `

export const cht_agent_icon = css`
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
    background-size: 100%;
    border-radius: 50%;
    margin-left: 10px;
    margin-right: 5px;        
  `

export const config_wrap = css`
    width: calc(100% - 570px);
    min-width: 500px;
    white-space: pre-wrap;
  `
export const chatBox = css`
    position: fixed;
    top: 100px;
    left: 50px;
    width: 400px;
    height: 600px;
  `

export const cht_container = css`
    position: absolute;
    inset: 75px 0px 65px;
    background-color: #ffffff;
    transition: top 1s ease 0s;
    padding-top: 30px;
    padding-left: 20px;
    white-space: pre-wrap;
    //padding-right: 1.2em;
`

export const cht_wrapper = css`
    overflow: hidden;
    width: calc(100% + 0.4em);
    //width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
    float: left;
`

export const cht_content = css`
    height: 100%;
    width: 100%;
    padding: 0px;
    position: relative;
    overflow: auto scroll;
    overscroll-behavior: none;
    box-sizing: border-box;
    ::-webkit-scrollbar {
        width: 7px;
    }
    ::-webkit-scrollbar-track {
        background-color: #eeeeee;
    }
    width: 100%;
    right: auto;
`

export const cht_agent_container = css`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    margin-right: 20px;
    margin-bottom: 15px;
    padding-right: 20px;
`

/* ユーザフキだし */
export const cht_customer_icon = css`
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
    background-size: 100%;
    border-radius: 50%;
    margin-left: 15px;        
  `

export const cht_customer_container = css`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: flex-start;
    align-content: flex-end;
    margin-left: 20px;
    margin-bottom: 15px;
    padding-right: 20px;
  `

export const cht_customer_bubble_cont = css`
    font-size: 18px;
    line-height: 1.8;
    color: #333;
    max-width: calc(100% - 60px);
    ::after {
        display: block;
        width: 0px;
        content: "";
        position: absolute;
        top: 8px;
        bottom: auto;
        right: -6px;
        border-style: solid;
        border-width: 7px 0px 7px 7px;
    }
    a {
        color: #3A76A4;
    }
`

/* チャット画面コンテナ */

/* チャット画面フッター */
export const cht_footer = css`
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-start;
    align-content: space-between;
    left: 0px;
    right: 0px;
    bottom: 0px;
    //height: 70px;
    //background: rgb(249, 251, 255);
    //border-radius: 0px 0px 10px 10px;
    font-size: 62.5%;
    border-top: 1px solid #666666;
    padding: 10px;
  `

  export const cht_footer_left = css`
    width: calc(100% - 40px);
    textarea {
        border: 0px;
        width: 100%;
        //background: rgb(249, 251, 255);
        resize: none;
        outline: 0px;
        //color: rgb(42, 47, 54);
        font-size: 18px;
        height: 40px;
        border-radius: 5px 5px 5px 5px;
        padding-left: 5px;
        padding-right: 5px;
    }
    input[type="text"], textarea {
        border: 0px;
        //background: rgb(249, 251, 255);
        outline: 0px;
        font-size: 1.5em;
    }
  `
  export const sendButton = css`
    margin: auto;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 34px;
    width: 34px;
    opacity: 1;
    cursor: pointer;
    background-color: transparent;
    border: none;
    :hover {
        opacity: 0.7;
    }
  `
  /* チャット画面フッター */

/* Index */
export const mv = css`
    padding: 42px 0 68px;
    background-color: #006180;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    h1 {
        width: 513px;
        margin: 0 auto 30px;
        padding: 0;
    }
`

export const mv_logo = css`
    position: absolute;
    top: 42px;
    left: 30px;
    width: 150px;
    z-index: 1;
`

export const mv_list = css`
    position: relative;
    width: 513px;
    margin: 0 auto;
    padding: 0;
    list-style: none;
    z-index: 1;
`

/* Index */

export const layoutBox = css`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between
`
export const tile_1 = css`
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    background: #FF7A5B;
    padding: 12px 35px 14px;
    color: #fff;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    border-radius: 25px;
    z-index: 1;
    sup {
        position: relative;
        top: 11px;
        right: 11px;
        font-size: 14px;
        font-weight: 400;
    }
`

export const text_2nd = css`
    position: relative;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.5;
    text-align: center;
    color: #fff;
    margin: 0;
    padding: 80px 0 0;
    z-index: 1;
`
export const actColor_1 = css`
    color: #FFC2B4;
`

export const text_3rd = css`
    position: relative;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    color: #fff;
    margin: 0;
    padding: 0;
    z-index: 1;
`

export const mt26 = css`
    margin-top: 26px !important;
`

export const pc_none = css`
    display: none;
`

export const sp_none = css`
    display: none;
`

export const btn_try = css`
    width: 464px;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    text-decoration: none;
    background: #FFD15B;
    padding: 16px 30px;
    color: #333333;
    font-size: 24px;
    font-weight: 700;
    border-radius: 40px;
    box-shadow: 0px 6px 0px 0px rgba(0, 0, 0, 0.5);
    margin: 0 auto;
    z-index: 1;
    ::after {
        content: '';
        display: inline-block;
        border-style: solid;
        border-width: 8px 0 8px 15px;
        border-color: transparent transparent transparent #000;
        margin-top: 2px;
    }
`

export const mt60 = css`
    margin-top: 60px !important;
`

export const icon_free = css`
    display: inline-block;
    padding: 2px 6px 3px 9px;
    background: #fff;
    border-radius: 4px;
    color: #FF7A5B;
    letter-spacing: 4px;
    text-align: center;
`

export const features = css`
    padding: 0 calc(100vw * 25 / 350) calc(100vw * 26 / 350);
`

export const actSize = css`
    font-size: 1.3em;
`
export const featuresInner = css`
    position: relative;
    z-index: 1;
    max-width: 1150px;
    margin: 60px auto 0;
    padding: 0 20px;
    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }
`

export const layout3_1 = css`
    width: 31.8%;
`

export const layout3_2 = css`
    width: 64%;
`

export const features_balloon = css`
    border-radius: calc(100vw * 20 / 350);
    padding: calc(100vw * 27 / 350) calc(100vw * 20 / 350) calc(100vw * 30 / 350);
    margin-bottom: calc(100vw * 35 / 350);
    h3 {
        font-size: calc(100vw * 16 / 350);
        margin: 0 0 calc(100vw * 13 / 350);
    }
    p {
        font-size: calc(100vw * 14 / 350);
    }
`

export const balloon_L = css`
    ::after {
        position: absolute;
        content: '';
        display: inline-block;
        border-style: solid;
        border-width: 14px 0 14px 23px;
        border-color: transparent transparent transparent #fff;
        top: 30px;
        right: -20px;
    }
`

export const cap01 = css`
    padding-bottom: calc(100vw * 30 / 350);
`

export const balloon_R = css`
    ::after {
        position: absolute;
        content: '';
        display: inline-block;
        border-style: solid;
        border-width: 14px 23px 14px 0;
        border-color: transparent #fff transparent transparent;
        top: 30px;
        left: -20px;
    }
`

export const service = css`
    padding: 0 0 68px;
    background-color: #006180;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`

export const text_2nd_2 = css`
    position: relative;
    font-size: 36px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    color: #fff;
    margin: 0;
    padding: 80px 0 0;
    z-index: 1;
`
export const service_list = css`
    position: relative;
    width: 513px;
    margin: 0 auto;
    padding: 0;
    list-style: none;
    z-index: 1;
    tile_1 {
        padding: 18px 35px 20px;
        border-radius: 45px;
    }
`

export const mt40 = css`
    margin-top: 40px !important;
`
export const service_notice = css`
    position: relative;
    width: 450px;
    margin: 40px auto 0;
    padding: 0;
    font-size: 14px;
    line-height: 1.8;
    color: #fff;
    z-index: 1;
    list-style: none;
`

export const service_step = css`
    position: relative;
    max-width: 1190px;
    list-style: none;
    margin: 30px auto 0;
    padding: 0 20px;
    z-index: 1;
    li {
        position: relative;
        width: 22.6%;
        text-align: center;
        padding: 23px 20px 32px;
        color: #333;
        border-radius: 20px;
        background-color: #fff;
        z-index: 1;
        ::after {
            position: absolute;
            content: '';
            display: inline-block;
            border-style: solid;
            border-width: 11px 0 11px 20px;
            border-color: transparent transparent transparent #fff;
            top: calc(50% - 10px);
            right: -28px;
        }
        :nth-child(4)::after {
            display: none;
        }
    }
`

export const icon_customer = css`
    width: 70px;
    display: block;
    padding: 2px 0 3px;
    background: #FF7A5B;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    margin: 0 auto;
`
export const icon_company = css`
    width: 70px;
    display: block;
    padding: 2px 0 3px;
    background: #55B2DC;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    margin: 0 auto;
`

export const service_step_text = css`
    display: block;
    margin-top: 17px;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.5;
    text-align: center;
    color: #333;
    a {
        color: #FF7A5B;
        text-decoration: none;
    }
`

export const mt100 = css`
    margin-top: 100px !important;
`

export const process = css`
    position: relative;
    padding: 0 0 68px;
    z-index: 1;
`

export const processInner = css`
    padding: 0 20px;
`
export const process_image2 = css`
  width: 54%;
`
export const process_image3  = css`
  width: 69%;
`
export const process_image4  = css`
  position: relative;
  width: 89%;
  ::after {
    content: "";
    width: 13.8%;
    height: 118px;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    right: -18%;
    top: 34%;
  }
`
export const process_image5 = css`
  width: 89%;
`

export const process_box = css`
    max-width: 1150px;
    margin: 0 auto;
`

export const tile_2 = css`
    position: relative;
    z-index: 1;
    background: #006180;
    padding: 12px 12px 12px 87px;
    color: #fff;
    border-radius: 30px;
    font-weight: 700;
`

export const title_2_no = css`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    position: absolute;
    top: -10px;
    left: -10px;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: #006180;
    border: solid 6px #55B2DC;
    font-size: 24px;
    line-height: 1;
    ::after {
        position: absolute;
        content: "";
        width: 50px;
        height: 50px;
        border: solid 1px #55B2DC;
        top: 4px;
        left: 4px;
        border-radius: 50%;
    }
`

export const process_imageBox = css`
    max-width: 1040px;
    margin: 30px auto 50px;
    list-style: none;
    padding: 0;
`

export const process_image1 = css`
    position: relative;
    width: 38%;
    ::after {
        content: "";
        width: 13.8%;
        height: 118px;
        background-image: url(../img/arrow.svg);
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        right: -18%;
        top: 34%;
    }
`